// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"iP1-4LovSt9EE_YRKPVXW"};